export const imagebossUrl = (imageUrl, dimensions = {}) => {
  const { width, height } = dimensions;

  // Is probably already an imageboss url with dimensions specified. It will be
  // for block preview.
  if (imageUrl?.match(/imageboss.*(width|height|cover)\/\d/)) return imageUrl;

  // Neither dimension given: there's no resize to ask for, so hand back the
  // original rather than building an operation out of the missing value.
  if (!width && !height) return imageUrl;

  if (!imageUrl?.includes(':dimensions')) {
    imageUrl = `https://img.imageboss.me/:dimensions/${imageUrl}`;
  }

  let urlDimensions;
  if (!!width && !!height) {
    // Imageboss says this will use the Shannon Entropy Algorithm to crop the
    // image to the center of it's content.
    urlDimensions = `cover:entropy/${width}x${height}`;
  } else if (!width) {
    urlDimensions = `height/${height}`;
  } else if (!height) {
    urlDimensions = `width/${width}`;
  }

  return imageUrl.replace(':dimensions', urlDimensions);
};
